@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_526_181_073)
public val Res.string.schedule_employee: StringResource by lazy {
      StringResource("string:schedule_employee", "schedule_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 272339, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 386035, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249722, 37),
      ))
    }

@delegate:ResourceContentHash(-339_284_223)
public val Res.string.schedule_enter_hours: StringResource by lazy {
      StringResource("string:schedule_enter_hours", "schedule_enter_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 272467, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 386243, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249850, 52),
      ))
    }

@delegate:ResourceContentHash(-1_607_313_946)
public val Res.string.schedule_enter_hours_hint: StringResource by lazy {
      StringResource("string:schedule_enter_hours_hint", "schedule_enter_hours_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 272377, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 386085, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249760, 89),
      ))
    }

@delegate:ResourceContentHash(1_815_524_557)
public val Res.string.schedule_hours_by_manager: StringResource by lazy {
      StringResource("string:schedule_hours_by_manager", "schedule_hours_by_manager", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 272524, 165),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 386324, 297),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 249903, 177),
      ))
    }

@delegate:ResourceContentHash(835_047_586)
public val Res.string.schedule_hours_confirmed: StringResource by lazy {
      StringResource("string:schedule_hours_confirmed", "schedule_hours_confirmed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 272690, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 386622, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250081, 72),
      ))
    }

@delegate:ResourceContentHash(398_819_151)
public val Res.string.schedule_hours_reported: StringResource by lazy {
      StringResource("string:schedule_hours_reported", "schedule_hours_reported", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 272771, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 386723, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250154, 83),
      ))
    }

@delegate:ResourceContentHash(-1_952_593_705)
public val Res.string.schedule_hours_sent: StringResource by lazy {
      StringResource("string:schedule_hours_sent", "schedule_hours_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 272855, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 386835, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250238, 63),
      ))
    }

@delegate:ResourceContentHash(254_282_398)
public val Res.string.schedule_manager_note: StringResource by lazy {
      StringResource("string:schedule_manager_note", "schedule_manager_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 272923, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 386931, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250302, 53),
      ))
    }

@delegate:ResourceContentHash(-1_166_192_411)
public val Res.string.schedule_marketplace_empty: StringResource by lazy {
      StringResource("string:schedule_marketplace_empty", "schedule_marketplace_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 272985, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 387013, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250356, 74),
      ))
    }

@delegate:ResourceContentHash(1_871_925_730)
public val Res.string.schedule_marketplace_request_at: StringResource by lazy {
      StringResource("string:schedule_marketplace_request_at", "schedule_marketplace_request_at", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273052, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 387096, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250431, 75),
      ))
    }

@delegate:ResourceContentHash(-2_083_239_521)
public val Res.string.schedule_marketplace_shifts: StringResource by lazy {
      StringResource("string:schedule_marketplace_shifts", "schedule_marketplace_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273132, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 387192, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250507, 59),
      ))
    }

@delegate:ResourceContentHash(186_714_315)
public val Res.string.schedule_my_shift: StringResource by lazy {
      StringResource("string:schedule_my_shift", "schedule_my_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273289, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 387373, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250652, 37),
      ))
    }

@delegate:ResourceContentHash(-1_183_744_771)
public val Res.string.schedule_my_shift_details: StringResource by lazy {
      StringResource("string:schedule_my_shift_details", "schedule_my_shift_details", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273196, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 387264, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250567, 45),
      ))
    }

@delegate:ResourceContentHash(-1_073_855_439)
public val Res.string.schedule_my_shifts: StringResource by lazy {
      StringResource("string:schedule_my_shifts", "schedule_my_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273246, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 387322, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250613, 38),
      ))
    }

@delegate:ResourceContentHash(1_930_472_757)
public val Res.string.schedule_no_rosters: StringResource by lazy {
      StringResource("string:schedule_no_rosters", "schedule_no_rosters", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273331, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 387423, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250690, 71),
      ))
    }

@delegate:ResourceContentHash(297_913_540)
public val Res.string.schedule_no_shifts: StringResource by lazy {
      StringResource("string:schedule_no_shifts", "schedule_no_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273399, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 387527, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250762, 70),
      ))
    }

@delegate:ResourceContentHash(716_816_900)
public val Res.string.schedule_open_shift: StringResource by lazy {
      StringResource("string:schedule_open_shift", "schedule_open_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273478, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 387634, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250833, 43),
      ))
    }

@delegate:ResourceContentHash(539_857_533)
public val Res.string.schedule_put_on_marketplace: StringResource by lazy {
      StringResource("string:schedule_put_on_marketplace", "schedule_put_on_marketplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273522, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 387694, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250877, 59),
      ))
    }

@delegate:ResourceContentHash(1_941_947_253)
public val Res.string.schedule_select_person: StringResource by lazy {
      StringResource("string:schedule_select_person", "schedule_select_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273582, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 387778, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250937, 50),
      ))
    }

@delegate:ResourceContentHash(1_783_459_156)
public val Res.string.schedule_send_hours: StringResource by lazy {
      StringResource("string:schedule_send_hours", "schedule_send_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273633, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 387845, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250988, 43),
      ))
    }

@delegate:ResourceContentHash(1_782_483_952)
public val Res.string.schedule_shift_at: StringResource by lazy {
      StringResource("string:schedule_shift_at", "schedule_shift_at", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273681, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 387917, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251032, 37),
      ))
    }

@delegate:ResourceContentHash(739_934_394)
public val Res.string.schedule_shifts_for: StringResource by lazy {
      StringResource("string:schedule_shifts_for", "schedule_shifts_for", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273723, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 387967, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251070, 47),
      ))
    }

@delegate:ResourceContentHash(-1_048_484_812)
public val Res.string.schedule_show_my_shifts: StringResource by lazy {
      StringResource("string:schedule_show_my_shifts", "schedule_show_my_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273771, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 388023, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251118, 51),
      ))
    }

@delegate:ResourceContentHash(-1_738_115_372)
public val Res.string.schedule_show_whole_day: StringResource by lazy {
      StringResource("string:schedule_show_whole_day", "schedule_show_whole_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273827, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 388103, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251170, 55),
      ))
    }

@delegate:ResourceContentHash(-604_692_450)
public val Res.string.schedule_swap_change: StringResource by lazy {
      StringResource("string:schedule_swap_change", "schedule_swap_change", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273887, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 388183, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251226, 48),
      ))
    }

@delegate:ResourceContentHash(1_141_815_719)
public val Res.string.schedule_swap_status_requested: StringResource by lazy {
      StringResource("string:schedule_swap_status_requested", "schedule_swap_status_requested", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 273940, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 388268, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251275, 58),
      ))
    }

@delegate:ResourceContentHash(-1_786_525_099)
public val Res.string.schedule_swap_with_person: StringResource by lazy {
      StringResource("string:schedule_swap_with_person", "schedule_swap_with_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 274015, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 388343, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251334, 57),
      ))
    }

@delegate:ResourceContentHash(1_620_471_748)
public val Res.string.schedule_swap_withdraw: StringResource by lazy {
      StringResource("string:schedule_swap_withdraw", "schedule_swap_withdraw", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 274133, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 388505, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251448, 54),
      ))
    }

@delegate:ResourceContentHash(-2_122_990_360)
public val Res.string.schedule_swap_withdrawn: StringResource by lazy {
      StringResource("string:schedule_swap_withdrawn", "schedule_swap_withdrawn", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 274077, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 388429, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251392, 55),
      ))
    }

@delegate:ResourceContentHash(-815_968_342)
public val Res.string.schedule_take_shift: StringResource by lazy {
      StringResource("string:schedule_take_shift", "schedule_take_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 274188, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 388580, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251503, 47),
      ))
    }

@delegate:ResourceContentHash(-772_383_311)
public val Res.string.schedule_update_hours: StringResource by lazy {
      StringResource("string:schedule_update_hours", "schedule_update_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 274240, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 388644, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251551, 45),
      ))
    }

@delegate:ResourceContentHash(56_276_416)
public val Res.string.schedule_waiting_for_approval_from: StringResource by lazy {
      StringResource("string:schedule_waiting_for_approval_from", "schedule_waiting_for_approval_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 274290, 90),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 388710, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251597, 82),
      ))
    }

@delegate:ResourceContentHash(-83_164_643)
public val Res.string.search: StringResource by lazy {
      StringResource("string:search", "search", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 274381, 22),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 388809, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251680, 22),
      ))
    }

@delegate:ResourceContentHash(-1_951_503_208)
public val Res.string.select_workplace: StringResource by lazy {
      StringResource("string:select_workplace", "select_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 274404, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 388840, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251703, 48),
      ))
    }

@delegate:ResourceContentHash(793_899_319)
public val Res.string.settings_accident_rate: StringResource by lazy {
      StringResource("string:settings_accident_rate", "settings_accident_rate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 274617, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 389165, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251904, 66),
      ))
    }

@delegate:ResourceContentHash(-1_562_674_435)
public val Res.string.settings_accident_rate_hint: StringResource by lazy {
      StringResource("string:settings_accident_rate_hint", "settings_accident_rate_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 274449, 167),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 388901, 263),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251752, 151),
      ))
    }

@delegate:ResourceContentHash(-566_843_361)
public val Res.string.settings_add_new_slot: StringResource by lazy {
      StringResource("string:settings_add_new_slot", "settings_add_new_slot", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 274680, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 389292, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 251971, 45),
      ))
    }

@delegate:ResourceContentHash(-327_724_902)
public val Res.string.settings_address: StringResource by lazy {
      StringResource("string:settings_address", "settings_address", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 275441, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 390433, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 252700, 36),
      ))
    }

@delegate:ResourceContentHash(-957_844_514)
public val Res.string.settings_address_no_matches: StringResource by lazy {
      StringResource("string:settings_address_no_matches", "settings_address_no_matches", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 274726, 135),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 389370, 243),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 252017, 119),
      ))
    }

@delegate:ResourceContentHash(-241_045_900)
public val Res.string.settings_address_not_found: StringResource by lazy {
      StringResource("string:settings_address_not_found", "settings_address_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 274862, 122),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 389614, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 252137, 122),
      ))
    }

@delegate:ResourceContentHash(919_868_239)
public val Res.string.settings_address_search_busy: StringResource by lazy {
      StringResource("string:settings_address_search_busy", "settings_address_search_busy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 274985, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 389797, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 252260, 104),
      ))
    }

@delegate:ResourceContentHash(1_690_854_772)
public val Res.string.settings_address_search_failed: StringResource by lazy {
      StringResource("string:settings_address_search_failed", "settings_address_search_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 275102, 154),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 389958, 218),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 252365, 154),
      ))
    }

@delegate:ResourceContentHash(-985_099_056)
public val Res.string.settings_address_search_help: StringResource by lazy {
      StringResource("string:settings_address_search_help", "settings_address_search_help", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 275257, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 390177, 180),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 252520, 104),
      ))
    }

@delegate:ResourceContentHash(-622_852_140)
public val Res.string.settings_address_searching: StringResource by lazy {
      StringResource("string:settings_address_searching", "settings_address_searching", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 275374, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 390358, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 252625, 74),
      ))
    }

@delegate:ResourceContentHash(-1_984_399_223)
public val Res.string.settings_availability_slots: StringResource by lazy {
      StringResource("string:settings_availability_slots", "settings_availability_slots", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 275474, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 390474, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 252737, 59),
      ))
    }

@delegate:ResourceContentHash(-224_714_904)
public val Res.string.settings_available_roles: StringResource by lazy {
      StringResource("string:settings_available_roles", "settings_available_roles", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 275538, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 390538, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 252797, 52),
      ))
    }

@delegate:ResourceContentHash(-1_585_380_740)
public val Res.string.settings_block_expired: StringResource by lazy {
      StringResource("string:settings_block_expired", "settings_block_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276030, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 391294, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253225, 78),
      ))
    }

@delegate:ResourceContentHash(1_379_396_826)
public val Res.string.settings_block_expired_hint: StringResource by lazy {
      StringResource("string:settings_block_expired_hint", "settings_block_expired_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 275587, 287),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 390611, 463),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 252850, 223),
      ))
    }

@delegate:ResourceContentHash(1_213_415_207)
public val Res.string.settings_block_expired_off: StringResource by lazy {
      StringResource("string:settings_block_expired_off", "settings_block_expired_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 275875, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 391075, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253074, 42),
      ))
    }

@delegate:ResourceContentHash(1_869_537_737)
public val Res.string.settings_block_expired_on: StringResource by lazy {
      StringResource("string:settings_block_expired_on", "settings_block_expired_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 275922, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 391142, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253117, 41),
      ))
    }

@delegate:ResourceContentHash(1_668_614_182)
public val Res.string.settings_block_expired_switch: StringResource by lazy {
      StringResource("string:settings_block_expired_switch", "settings_block_expired_switch", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 275964, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 391200, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253159, 65),
      ))
    }

@delegate:ResourceContentHash(-2_044_533_257)
public val Res.string.settings_blood_donation_days: StringResource by lazy {
      StringResource("string:settings_blood_donation_days", "settings_blood_donation_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276109, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 391437, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253304, 92),
      ))
    }

@delegate:ResourceContentHash(981_373_517)
public val Res.string.settings_break_minutes: StringResource by lazy {
      StringResource("string:settings_break_minutes", "settings_break_minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276202, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 391578, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253397, 50),
      ))
    }

@delegate:ResourceContentHash(-1_499_092_863)
public val Res.string.settings_break_none: StringResource by lazy {
      StringResource("string:settings_break_none", "settings_break_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276253, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 391669, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253448, 35),
      ))
    }

@delegate:ResourceContentHash(2_107_553_968)
public val Res.string.settings_break_paid: StringResource by lazy {
      StringResource("string:settings_break_paid", "settings_break_paid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276289, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 391713, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253484, 67),
      ))
    }

@delegate:ResourceContentHash(344_698_638)
public val Res.string.settings_break_reminder: StringResource by lazy {
      StringResource("string:settings_break_reminder", "settings_break_reminder", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276503, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 391991, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253670, 51),
      ))
    }

@delegate:ResourceContentHash(532_377_071)
public val Res.string.settings_break_reminder_after: StringResource by lazy {
      StringResource("string:settings_break_reminder_after", "settings_break_reminder_after", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276385, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 391833, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253552, 77),
      ))
    }

@delegate:ResourceContentHash(713_652_361)
public val Res.string.settings_break_reminder_off: StringResource by lazy {
      StringResource("string:settings_break_reminder_off", "settings_break_reminder_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276451, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 391931, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253630, 39),
      ))
    }

@delegate:ResourceContentHash(-958_235_584)
public val Res.string.settings_break_unpaid: StringResource by lazy {
      StringResource("string:settings_break_unpaid", "settings_break_unpaid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276567, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 392083, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253722, 45),
      ))
    }

@delegate:ResourceContentHash(-1_979_998_326)
public val Res.string.settings_breaks: StringResource by lazy {
      StringResource("string:settings_breaks", "settings_breaks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276621, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 392165, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253768, 31),
      ))
    }

@delegate:ResourceContentHash(1_971_141_436)
public val Res.string.settings_care_allowance_days: StringResource by lazy {
      StringResource("string:settings_care_allowance_days", "settings_care_allowance_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276657, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 392209, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253800, 80),
      ))
    }

@delegate:ResourceContentHash(-282_347_018)
public val Res.string.settings_care_child: StringResource by lazy {
      StringResource("string:settings_care_child", "settings_care_child", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276746, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 392334, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253881, 43),
      ))
    }

@delegate:ResourceContentHash(1_448_269_735)
public val Res.string.settings_care_days: StringResource by lazy {
      StringResource("string:settings_care_days", "settings_care_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276790, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 392386, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253925, 114),
      ))
    }

@delegate:ResourceContentHash(-1_100_775_429)
public val Res.string.settings_care_family: StringResource by lazy {
      StringResource("string:settings_care_family", "settings_care_family", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276905, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 392557, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 254040, 52),
      ))
    }

@delegate:ResourceContentHash(-1_104_833_063)
public val Res.string.settings_care_total: StringResource by lazy {
      StringResource("string:settings_care_total", "settings_care_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 276958, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 392626, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 254093, 47),
      ))
    }

@delegate:ResourceContentHash(10_511_714)
public val Res.string.settings_carer_leave_days: StringResource by lazy {
      StringResource("string:settings_carer_leave_days", "settings_carer_leave_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 277006, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 392698, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 254141, 77),
      ))
    }

@delegate:ResourceContentHash(1_225_865_278)
public val Res.string.settings_checklist_alert: StringResource by lazy {
      StringResource("string:settings_checklist_alert", "settings_checklist_alert", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 277389, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 393345, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 254512, 60),
      ))
    }

@delegate:ResourceContentHash(-1_896_047_073)
public val Res.string.settings_checklist_alert_after: StringResource by lazy {
      StringResource("string:settings_checklist_alert_after", "settings_checklist_alert_after", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 277088, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 392852, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 254219, 74),
      ))
    }

@delegate:ResourceContentHash(-1_217_783_761)
public val Res.string.settings_checklist_alert_desc: StringResource by lazy {
      StringResource("string:settings_checklist_alert_desc", "settings_checklist_alert_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 277163, 225),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 392971, 373),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 254294, 217),
      ))
    }

@delegate:ResourceContentHash(-521_618_227)
public val Res.string.settings_childcare_limit: StringResource by lazy {
      StringResource("string:settings_childcare_limit", "settings_childcare_limit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 277462, 96),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 393442, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 254573, 92),
      ))
    }

@delegate:ResourceContentHash(55_476_577)
public val Res.string.settings_clock_count_from_plan: StringResource by lazy {
      StringResource("string:settings_clock_count_from_plan", "settings_clock_count_from_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 277848, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 394024, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 254883, 82),
      ))
    }

@delegate:ResourceContentHash(-1_918_469_461)
public val Res.string.settings_clock_count_from_plan_explained: StringResource by lazy {
      StringResource("string:settings_clock_count_from_plan_explained", "settings_clock_count_from_plan_explained", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 277559, 288),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 393583, 440),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 254666, 216),
      ))
    }

@delegate:ResourceContentHash(-761_142_434)
public val Res.string.settings_clock_early_in: StringResource by lazy {
      StringResource("string:settings_clock_early_in", "settings_clock_early_in", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 277935, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 394159, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 254966, 87),
      ))
    }

@delegate:ResourceContentHash(1_474_952_429)
public val Res.string.settings_clock_late_out: StringResource by lazy {
      StringResource("string:settings_clock_late_out", "settings_clock_late_out", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 278039, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 394279, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 255054, 87),
      ))
    }

@delegate:ResourceContentHash(-1_618_933_945)
public val Res.string.settings_clock_minutes: StringResource by lazy {
      StringResource("string:settings_clock_minutes", "settings_clock_minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 278139, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 394399, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 255142, 42),
      ))
    }

@delegate:ResourceContentHash(486_423_789)
public val Res.string.settings_clock_no_app: StringResource by lazy {
      StringResource("string:settings_clock_no_app", "settings_clock_no_app", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 278374, 101),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 394686, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 255337, 85),
      ))
    }

@delegate:ResourceContentHash(-394_383_396)
public val Res.string.settings_clock_no_app_explained: StringResource by lazy {
      StringResource("string:settings_clock_no_app_explained", "settings_clock_no_app_explained", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 278186, 187),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 394458, 227),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 255185, 151),
      ))
    }

@delegate:ResourceContentHash(713_652_361)
public val Res.string.settings_clock_off: StringResource by lazy {
      StringResource("string:settings_clock_off", "settings_clock_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 278476, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 394856, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 255423, 30),
      ))
    }

@delegate:ResourceContentHash(-80_578_797)
public val Res.string.settings_clock_overrun: StringResource by lazy {
      StringResource("string:settings_clock_overrun", "settings_clock_overrun", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 278519, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 394907, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 255454, 82),
      ))
    }

@delegate:ResourceContentHash(496_413_363)
public val Res.string.settings_clock_photo: StringResource by lazy {
      StringResource("string:settings_clock_photo", "settings_clock_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 278961, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 395629, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 255864, 72),
      ))
    }

@delegate:ResourceContentHash(-1_500_635_420)
public val Res.string.settings_clock_photo_explained: StringResource by lazy {
      StringResource("string:settings_clock_photo_explained", "settings_clock_photo_explained", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 278602, 358),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 395018, 610),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 255537, 326),
      ))
    }

@delegate:ResourceContentHash(-111_549_377)
public val Res.string.settings_clock_qr_only: StringResource by lazy {
      StringResource("string:settings_clock_qr_only", "settings_clock_qr_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 279247, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 395975, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256090, 66),
      ))
    }

@delegate:ResourceContentHash(425_432_883)
public val Res.string.settings_clock_qr_only_explained: StringResource by lazy {
      StringResource("string:settings_clock_qr_only_explained", "settings_clock_qr_only_explained", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 279050, 196),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 395738, 236),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 255937, 152),
      ))
    }

@delegate:ResourceContentHash(-80_892_344)
public val Res.string.settings_clock_review: StringResource by lazy {
      StringResource("string:settings_clock_review", "settings_clock_review", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 279542, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 396386, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256329, 49),
      ))
    }

@delegate:ResourceContentHash(318_382_298)
public val Res.string.settings_clock_review_explained: StringResource by lazy {
      StringResource("string:settings_clock_review_explained", "settings_clock_review_explained", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 279310, 231),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 396062, 323),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256157, 171),
      ))
    }

@delegate:ResourceContentHash(-889_580_261)
public val Res.string.settings_clock_same_tablet: StringResource by lazy {
      StringResource("string:settings_clock_same_tablet", "settings_clock_same_tablet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 279600, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 396472, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256379, 78),
      ))
    }

@delegate:ResourceContentHash(470_749_934)
public val Res.string.settings_clock_seconds: StringResource by lazy {
      StringResource("string:settings_clock_seconds", "settings_clock_seconds", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 279687, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 396603, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256458, 46),
      ))
    }

@delegate:ResourceContentHash(1_197_623_184)
public val Res.string.settings_clock_very_short: StringResource by lazy {
      StringResource("string:settings_clock_very_short", "settings_clock_very_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 279734, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 396662, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256505, 57),
      ))
    }

@delegate:ResourceContentHash(-1_514_559_093)
public val Res.string.settings_commission_hint: StringResource by lazy {
      StringResource("string:settings_commission_hint", "settings_commission_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 279796, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 396740, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256563, 92),
      ))
    }

@delegate:ResourceContentHash(-846_961_776)
public val Res.string.settings_commission_percent: StringResource by lazy {
      StringResource("string:settings_commission_percent", "settings_commission_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 279913, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 396893, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256656, 51),
      ))
    }

@delegate:ResourceContentHash(-1_176_470_683)
public val Res.string.settings_coordinates_by_hand: StringResource by lazy {
      StringResource("string:settings_coordinates_by_hand", "settings_coordinates_by_hand", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 279965, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 396953, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256708, 72),
      ))
    }

@delegate:ResourceContentHash(551_290_948)
public val Res.string.settings_coordinates_found: StringResource by lazy {
      StringResource("string:settings_coordinates_found", "settings_coordinates_found", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280042, 126),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 397054, 194),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256781, 118),
      ))
    }

@delegate:ResourceContentHash(-1_405_021_638)
public val Res.string.settings_currency: StringResource by lazy {
      StringResource("string:settings_currency", "settings_currency", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280169, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 397249, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256900, 37),
      ))
    }

@delegate:ResourceContentHash(-1_207_360_629)
public val Res.string.settings_days_count: StringResource by lazy {
      StringResource("string:settings_days_count", "settings_days_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280203, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 397291, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256938, 39),
      ))
    }

@delegate:ResourceContentHash(575_205_084)
public val Res.string.settings_days_or_hours: StringResource by lazy {
      StringResource("string:settings_days_or_hours", "settings_days_or_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280243, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 397339, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256978, 62),
      ))
    }

@delegate:ResourceContentHash(-1_680_696_562)
public val Res.string.settings_edit_availability_slots: StringResource by lazy {
      StringResource("string:settings_edit_availability_slots", "settings_edit_availability_slots", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280306, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 397418, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257041, 72),
      ))
    }

@delegate:ResourceContentHash(-1_979_998_326)
public val Res.string.settings_edit_breaks: StringResource by lazy {
      StringResource("string:settings_edit_breaks", "settings_edit_breaks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280387, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 397515, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257114, 36),
      ))
    }

@delegate:ResourceContentHash(-1_238_735_041)
public val Res.string.settings_edit_clock_review: StringResource by lazy {
      StringResource("string:settings_edit_clock_review", "settings_edit_clock_review", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280428, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 397564, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257151, 62),
      ))
    }

@delegate:ResourceContentHash(-1_292_965_573)
public val Res.string.settings_edit_financials: StringResource by lazy {
      StringResource("string:settings_edit_financials", "settings_edit_financials", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280503, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 397675, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257214, 52),
      ))
    }

@delegate:ResourceContentHash(-1_320_025_261)
public val Res.string.settings_edit_labour_budget: StringResource by lazy {
      StringResource("string:settings_edit_labour_budget", "settings_edit_labour_budget", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 280556, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 397756, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 257267, 59),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString34Resources(map: MutableMap<String, StringResource>) {
  map.put("schedule_employee", Res.string.schedule_employee)
  map.put("schedule_enter_hours", Res.string.schedule_enter_hours)
  map.put("schedule_enter_hours_hint", Res.string.schedule_enter_hours_hint)
  map.put("schedule_hours_by_manager", Res.string.schedule_hours_by_manager)
  map.put("schedule_hours_confirmed", Res.string.schedule_hours_confirmed)
  map.put("schedule_hours_reported", Res.string.schedule_hours_reported)
  map.put("schedule_hours_sent", Res.string.schedule_hours_sent)
  map.put("schedule_manager_note", Res.string.schedule_manager_note)
  map.put("schedule_marketplace_empty", Res.string.schedule_marketplace_empty)
  map.put("schedule_marketplace_request_at", Res.string.schedule_marketplace_request_at)
  map.put("schedule_marketplace_shifts", Res.string.schedule_marketplace_shifts)
  map.put("schedule_my_shift", Res.string.schedule_my_shift)
  map.put("schedule_my_shift_details", Res.string.schedule_my_shift_details)
  map.put("schedule_my_shifts", Res.string.schedule_my_shifts)
  map.put("schedule_no_rosters", Res.string.schedule_no_rosters)
  map.put("schedule_no_shifts", Res.string.schedule_no_shifts)
  map.put("schedule_open_shift", Res.string.schedule_open_shift)
  map.put("schedule_put_on_marketplace", Res.string.schedule_put_on_marketplace)
  map.put("schedule_select_person", Res.string.schedule_select_person)
  map.put("schedule_send_hours", Res.string.schedule_send_hours)
  map.put("schedule_shift_at", Res.string.schedule_shift_at)
  map.put("schedule_shifts_for", Res.string.schedule_shifts_for)
  map.put("schedule_show_my_shifts", Res.string.schedule_show_my_shifts)
  map.put("schedule_show_whole_day", Res.string.schedule_show_whole_day)
  map.put("schedule_swap_change", Res.string.schedule_swap_change)
  map.put("schedule_swap_status_requested", Res.string.schedule_swap_status_requested)
  map.put("schedule_swap_with_person", Res.string.schedule_swap_with_person)
  map.put("schedule_swap_withdraw", Res.string.schedule_swap_withdraw)
  map.put("schedule_swap_withdrawn", Res.string.schedule_swap_withdrawn)
  map.put("schedule_take_shift", Res.string.schedule_take_shift)
  map.put("schedule_update_hours", Res.string.schedule_update_hours)
  map.put("schedule_waiting_for_approval_from", Res.string.schedule_waiting_for_approval_from)
  map.put("search", Res.string.search)
  map.put("select_workplace", Res.string.select_workplace)
  map.put("settings_accident_rate", Res.string.settings_accident_rate)
  map.put("settings_accident_rate_hint", Res.string.settings_accident_rate_hint)
  map.put("settings_add_new_slot", Res.string.settings_add_new_slot)
  map.put("settings_address", Res.string.settings_address)
  map.put("settings_address_no_matches", Res.string.settings_address_no_matches)
  map.put("settings_address_not_found", Res.string.settings_address_not_found)
  map.put("settings_address_search_busy", Res.string.settings_address_search_busy)
  map.put("settings_address_search_failed", Res.string.settings_address_search_failed)
  map.put("settings_address_search_help", Res.string.settings_address_search_help)
  map.put("settings_address_searching", Res.string.settings_address_searching)
  map.put("settings_availability_slots", Res.string.settings_availability_slots)
  map.put("settings_available_roles", Res.string.settings_available_roles)
  map.put("settings_block_expired", Res.string.settings_block_expired)
  map.put("settings_block_expired_hint", Res.string.settings_block_expired_hint)
  map.put("settings_block_expired_off", Res.string.settings_block_expired_off)
  map.put("settings_block_expired_on", Res.string.settings_block_expired_on)
  map.put("settings_block_expired_switch", Res.string.settings_block_expired_switch)
  map.put("settings_blood_donation_days", Res.string.settings_blood_donation_days)
  map.put("settings_break_minutes", Res.string.settings_break_minutes)
  map.put("settings_break_none", Res.string.settings_break_none)
  map.put("settings_break_paid", Res.string.settings_break_paid)
  map.put("settings_break_reminder", Res.string.settings_break_reminder)
  map.put("settings_break_reminder_after", Res.string.settings_break_reminder_after)
  map.put("settings_break_reminder_off", Res.string.settings_break_reminder_off)
  map.put("settings_break_unpaid", Res.string.settings_break_unpaid)
  map.put("settings_breaks", Res.string.settings_breaks)
  map.put("settings_care_allowance_days", Res.string.settings_care_allowance_days)
  map.put("settings_care_child", Res.string.settings_care_child)
  map.put("settings_care_days", Res.string.settings_care_days)
  map.put("settings_care_family", Res.string.settings_care_family)
  map.put("settings_care_total", Res.string.settings_care_total)
  map.put("settings_carer_leave_days", Res.string.settings_carer_leave_days)
  map.put("settings_checklist_alert", Res.string.settings_checklist_alert)
  map.put("settings_checklist_alert_after", Res.string.settings_checklist_alert_after)
  map.put("settings_checklist_alert_desc", Res.string.settings_checklist_alert_desc)
  map.put("settings_childcare_limit", Res.string.settings_childcare_limit)
  map.put("settings_clock_count_from_plan", Res.string.settings_clock_count_from_plan)
  map.put("settings_clock_count_from_plan_explained", Res.string.settings_clock_count_from_plan_explained)
  map.put("settings_clock_early_in", Res.string.settings_clock_early_in)
  map.put("settings_clock_late_out", Res.string.settings_clock_late_out)
  map.put("settings_clock_minutes", Res.string.settings_clock_minutes)
  map.put("settings_clock_no_app", Res.string.settings_clock_no_app)
  map.put("settings_clock_no_app_explained", Res.string.settings_clock_no_app_explained)
  map.put("settings_clock_off", Res.string.settings_clock_off)
  map.put("settings_clock_overrun", Res.string.settings_clock_overrun)
  map.put("settings_clock_photo", Res.string.settings_clock_photo)
  map.put("settings_clock_photo_explained", Res.string.settings_clock_photo_explained)
  map.put("settings_clock_qr_only", Res.string.settings_clock_qr_only)
  map.put("settings_clock_qr_only_explained", Res.string.settings_clock_qr_only_explained)
  map.put("settings_clock_review", Res.string.settings_clock_review)
  map.put("settings_clock_review_explained", Res.string.settings_clock_review_explained)
  map.put("settings_clock_same_tablet", Res.string.settings_clock_same_tablet)
  map.put("settings_clock_seconds", Res.string.settings_clock_seconds)
  map.put("settings_clock_very_short", Res.string.settings_clock_very_short)
  map.put("settings_commission_hint", Res.string.settings_commission_hint)
  map.put("settings_commission_percent", Res.string.settings_commission_percent)
  map.put("settings_coordinates_by_hand", Res.string.settings_coordinates_by_hand)
  map.put("settings_coordinates_found", Res.string.settings_coordinates_found)
  map.put("settings_currency", Res.string.settings_currency)
  map.put("settings_days_count", Res.string.settings_days_count)
  map.put("settings_days_or_hours", Res.string.settings_days_or_hours)
  map.put("settings_edit_availability_slots", Res.string.settings_edit_availability_slots)
  map.put("settings_edit_breaks", Res.string.settings_edit_breaks)
  map.put("settings_edit_clock_review", Res.string.settings_edit_clock_review)
  map.put("settings_edit_financials", Res.string.settings_edit_financials)
  map.put("settings_edit_labour_budget", Res.string.settings_edit_labour_budget)
}
